import React from "react";
// import { Button } from "../button/button";

import police from '../../assets/menu/police.jpg';
import work from '../../assets/menu/work.jpg';
import medi from '../../assets/menu/medi.jpg';
import reg from '../../assets/menu/reg.jpg';
import arenda from '../../assets/menu/arenda.jpg';
import granica from '../../assets/menu/granica.jpg';
import sud from '../../assets/menu/sud.jpg';

import './game-menu.css';

export class GameMenu extends React.Component {
  render() {
    return (
      <div className="game-menu">
        <div className="game-menu__headline">
          Выбор игры
                </div>
        <div className="game-menu__content">
          <div onClick={() => { this.props.onClick(1) }} className="game-menu__menu-item">
            <img src={police} alt="полицейский" />
            <span>
              Задержала <br />
              полиция
            </span>
          </div>
          <div onClick={() => { this.props.onClick(2) }} className="game-menu__menu-item">
            <img src={work} alt="работа" />
            <span>
              Найти <br />
              работу
            </span>
          </div>
          <div onClick={() => { this.props.onClick(3) }} className="game-menu__menu-item">
            <img src={medi} alt="" />
            <span>
              Медицина <br />
              и <br />
              соц помощь
            </span>
          </div>
          <div onClick={() => { this.props.onClick(4) }} className="game-menu__menu-item">
            <img src={reg} alt="" />
            <span>
              Сделать<br />
              регистрацию
            </span>
          </div>
          <div onClick={() => { this.props.onClick(5) }} className="game-menu__menu-item">
            <img src={arenda} alt="" />
            <span>
              Аренда <br />
              жилья
            </span>
          </div>
          <div onClick={() => { this.props.onClick(6) }} className="game-menu__menu-item">
            <img src={granica} alt="" />
            <span>
              Пересечение <br />
              границы
            </span>
          </div>
          <div onClick={() => { this.props.onClick(7) }} className="game-menu__menu-item">
            <img src={sud} alt="" />
            <span>
              Суд
            </span>
          </div>
        </div>
      </div>
    );
  }
}
